import type { SortState } from '@/lib/sortRows';

export const BackendType = {
  DEFAULT: 'default',
  CPMS: 'cpms',
} as const;

export type BackendType = (typeof BackendType)[keyof typeof BackendType];

/** Paged envelope the CMX backend's scoped list endpoints return (PagedResult<T>). */
export interface PagedResultDto<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

/** One page of mapped rows plus the filter-level total that drives the footer. */
export interface RowsPage<T> {
  rows: T[];
  total: number;
}

/**
 * The `sort`/`dir` params a CMX list endpoint reads (`PagedQuery`), or nothing at all
 * when the table is in the endpoint's default order. Spread into a request's `params`.
 *
 * The key travels as the *table's* column name, which the endpoint resolves through its
 * own `SortMap` whitelist — so a key the endpoint does not offer is a 400, not a page
 * that comes back in the wrong order. Keep the union type beside each query hook in step
 * with the map in its controller.
 */
export function sortParams(sort: SortState | undefined) {
  return sort ? { sort: sort.key, dir: sort.direction } : {};
}

declare module 'axios' {
  export interface AxiosRequestConfig {
    backendType?: BackendType;
  }
}
